import { render, staticRenderFns } from "./UserSortFilter.vue?vue&type=template&id=ea1ef402&"
import script from "./UserSortFilter.vue?vue&type=script&lang=js&"
export * from "./UserSortFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports